var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box"},[_c('div',{class:['box-content', _vm.boxClasses.boxSize, _vm.boxClasses.fontSize]},[_vm._v(" "+_vm._s(_vm.boxText)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }